import Heading from 'components/atoms/Heading/Heading';
import RegistrationCard from 'components/atoms/RegistrationCard/RegistrationCard';
import Txt from 'components/atoms/Txt/Txt';
import { useNamespace } from 'components/templates/Translation/TranslationWrapper';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from './assets/all-set-email.svg';
import classes from './RequiresEmailConfirmation.module.scss';

export interface Props {}

export default function RequiresEmailConfirmation() {
  const router = useRouter();
  const namespace = useNamespace();
  const { t } = useTranslation(namespace);
  return (
    <RegistrationCard
      title={'Check your messages'}
      stepTitleClassName={classes.center}
      narrowContainer
    >
      <Txt skipTranslation={true} component="p" className={classes.center}>
        {router.query.email ? (
          router.query.email.includes('@') ? (
            <Txt>
              We&apos;ve sent an email to{' '}
              {{ email: router.query.email ?? t('the email address you provided') }}. Please go to
              your inbox and verify your account.
            </Txt>
          ) : (
            <Txt>
              We&apos;ve sent an SMS to{' '}
              {{ phonenumber: router.query.email ?? t('the mobile number you provided') }}. Click
              the link inside to verify your account.
            </Txt>
          )
        ) : (
          <Txt>
            We&apos;ve sent an email or text message to the contact details you provided. Please
            check your messages and verify your account.
          </Txt>
        )}
      </Txt>
    </RegistrationCard>
  );
}
